export default "__VITE_ASSET__RXq0Q42O__"